import {assert} from 'assert-ts';
import type {CodeListMap} from 'schemaDefinition/types';
import type {CodeListId} from 'services/codelists/types';
import type {ManifestationImportProps} from 'services/metadata/types';
import {getRestrictedManifestationCodelist} from './getRestrictedManifestationCodelist';

export const getRestrictedManifestationCodelists = (
  importProps: ManifestationImportProps,
  outerCodelists: CodeListMap,
): CodeListMap => {
  if (importProps === undefined) {
    return outerCodelists;
  }

  const restrictedCodelists = {...outerCodelists};

  Object.keys(restrictedCodelists).forEach(key => {
    const id = key as CodeListId;
    const outer = assert(outerCodelists[id]);
    restrictedCodelists[id] = getRestrictedManifestationCodelist(
      importProps,
      outer,
    );
  });

  return restrictedCodelists;
};
